import { render } from "./VideoCarouselSkeleton.vue?vue&type=template&id=6795e02a"
import script from "./VideoCarouselSkeleton.vue?vue&type=script&lang=js"
export * from "./VideoCarouselSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/seeroo-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__